import { showLoading, hideLoading } from "../status/status-actions"
import { mapValues, keys, values, map, reduce } from 'lodash'
import { toCurrency } from '../../util'


const supplyProductData = (productData) => ({
    type: "SUPPLY_PRODUCT_DATA",
    productData  
})

// This will request the product data from the endpoint. You can call this when it is convenient, and the
// result is cached. We usually want to call this after a successful submission of step-1 data, so that it
// will precache the data for subsequent steps, making the UX a bit nicer.
// If you use the @withProductData decorator, this action will be automatically called when the step component
// is mounted. 
export const requestProductData = (callback = null) => {

    return (dispatch, getState) => {
        const state = getState();
        
        // If the productData has already loaded, or is in the process of loading,
        // bail out.
        if(state.productData.loaded || state.productData.loading){
            if(state.productData.loaded && callback) callback();
            return;
        }

        dispatch({
            type: "REQUEST_PRODUCT_DATA"
        })
        
        dispatch( showLoading("request product data") )

        dispatch((dispatch, getState) =>{

            const state = getState();
            const numLoading = state.status.loads;

            if(!state.productOptions){
                console.log("Requesting Product Options")
                const axios = state.productData.axios
                const endpoints = state.productData.endpoints
                
                const request:(string) => Promise<any> = (endpoint) => axios.get(endpoint + "?token=" + state.fields.token);
                var result:any = {};
                
                // Request excesses
                // Then format a convenient format for selection options.
                // In Redux panel, see: state.productData.excesses
                request(endpoints.excesses)
                .then(response => {
                    console.log("Response excesses");
                    console.log(response.data)
                    result.excesses = 
                        mapValues( response.data.excesses, type => 
                            mapValues(type, options =>
                                values( mapValues(options, option =>
                                    ({ label: "$" + toCurrency(option.amount), value: option.amount })))));
                    console.log("Result")
                    console.log(result.excesses);
                })

                // Request options
                // Then format to a convenient structure for selection options.
                // In Redux panel, see: state.productData.options
                .then(_ => request(endpoints.options))
                .then(response => {
                    console.log("Response data")
                    console.log(response.data)
                    result.productOptions = 
                        mapValues(response.data.productOptions, options =>
                            values( mapValues(options, option =>
                                ({ label: option.description, value: option.code }))))
                })
                
                // Request sumsinsured
                // Then format to a convenient structure for selection options.
                // In Redux panel, see: state.productData.sumsinsured
                .then(_ => request(endpoints.sumsinsured))
                .then(response => {
                    console.log("Response sumsinsured");
                    console.log(response.data)
                    result.productSumsInsured = 
                        mapValues(response.data.productSumsInsured, options =>
                            values( mapValues(options, option =>
                                ({ label: option.description, value: option.amount }))))
                })

                // Request limits
                // Then format to a convenient structure for component use.
                // In Redux panel, see: state.productData.productLimits
                .then(_ => request(endpoints.limits))
                .then(response => {
                    console.log("Response limits");
                    console.log(response.data)
                    result.productLimits = 
                    mapValues(response.data.productLimits, limits =>
                        reduce(limits, (acc, limit) => ({ ...acc, [limit.code]:limit }), {}))
                })

                // Request payment options
                // Then format to a convenient structure for component use.
                // In Redux panel, see: state.productData.paymentOptions
                .then(_ => request(endpoints.paymentOptions))
                .then(response => {
                    console.log("Response paymentOptions");
                    console.log(response.data)
                    result.paymentOptions = response.data.paymentOptions
                    result.mpfPremiumMin = response.data.mpfPremiumMin
                    result.mpfPremiumMax = response.data.mpfPremiumMax
                })

                // After all the data has been processed, persist it to the store through
                // the supplyProductData action.
                .then(_ => {
                    console.log("PRODUCT DATA")
                    console.log(result)
                    dispatch( supplyProductData(result) )
                    dispatch(function(disaptch, getState){
                        if(callback) callback();
                    })
                    dispatch(function(dispatch, getState){
                        if(getState().status.loads == numLoading) dispatch( hideLoading("product data success") )
                    })
                })
                
                // Catch the errors
                .catch(err => {
                    console.log("Request Failed!")
                    console.log(err)
                    dispatch(function(dispatch, getState){
                        if(getState().status.loads == numLoading) dispatch( hideLoading("product data error") )
                    })
                })

            }
        })

    }

}


export default{
    requestProductData
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/product-data/product-data-actions.ts